export const extensionUrl =
  'https://chrome.google.com/webstore/detail/the-swarm/lcjkpibehhcnoniclgodcdmninnmgggi';

export const goToChromeExtension = () => window.open(extensionUrl, '_blank');
